export const addFaviconInDOM = faviconUrl => {
  if (faviconUrl) {
    document.head.insertAdjacentHTML(
      'beforeend',
      `<link rel="icon" href=${faviconUrl} />`
    );
    document.head.insertAdjacentHTML(
      'beforeend',
      `<link rel="apple-touch-icon" href=${faviconUrl} />`
    );
  }
};

export const addTitleInDom = title => {
  if (title) document.title = `${title} - Test Interface`;
};

export const getTestSlugFromPath = (pathname = window.location.pathname) => {
  const match =
    pathname.match(/^\/test-report\/([^/]+)/) ||
    pathname.match(/^\/test\/([^/]+)/) ||
    pathname.match(/^\/([^/]+)\/onboarding/);
  return match ? match[1] : null;
};
